import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import { getSessionDetailsAgainstSubEnrolId } from "../../redux/features/CRDslice";
import { useSelector } from "react-redux";
import Loader3D from "../../components/Loader/Loader3D";
const SessionCountAndDetails = ({ seletctedSubEnrollmentId }) => {
  const { monthWiseDataloading, monthWiseSessionData } = useSelector(
    (state) => state.crd
  );
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      dispatch(getSessionDetailsAgainstSubEnrolId(seletctedSubEnrollmentId));
    }
  }, [open]);
  return (
    <GlobalDialog
      maxWidth={"md"}
      fullWidth
      title={"Details"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <Button onClick={() => setOpen(true)}>
            <Icon
              style={{ marginRight: "3px" }}
              icon="carbon:view"
              width="20"
              height="20"
            />
            <Typography variant="button"> Session Count And Details</Typography>
          </Button>
        </>
      }
      content={
        <>
          {open ? (
            monthWiseDataloading ? (
              <Loader3D />
            ) : (
              monthWiseSessionData.length > 0 && (
                <Box>
                  <TableContainer
                    sx={{ border: "1px solid #ccc", borderRadius: "8px" }}
                  >
                    <Table sx={{ minWidth: 650, borderCollapse: "collapse" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="center"
                            sx={{
                              border: "1px solid #ccc",
                              fontWeight: "bold",
                            }}
                          >
                            Month And Year
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              border: "1px solid #ccc",
                              fontWeight: "bold",
                            }}
                          >
                            Total Session
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              border: "1px solid #ccc",
                              fontWeight: "bold",
                            }}
                          >
                            Completed Session
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {monthWiseSessionData.map((data, idx) => (
                          <TableRow key={idx}>
                            <TableCell
                              align="center"
                              sx={{ border: "1px solid #ccc" }}
                            >
                              {data?.session_month}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{ border: "1px solid #ccc" }}
                            >
                              {data?.total_sessions}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{ border: "1px solid #ccc" }}
                            >
                              {data?.completed_sessions}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              )
            )
          ) : null}
        </>
      }
    />
  );
};

export default memo(SessionCountAndDetails);
